// Centralized Color Theme
// Change these values to update the entire website color scheme

export const colors = {
  // Background colors
  bg: "#ffffff",
  bg2: "#ffffff",
  
  // Surface colors
  surface: "#ffffff",
  surface2: "#ffffff",

  ft: "#e9e9e9",
  
  // Accent/Primary colors
  // accent: "#FF4A4A",
  // accent2: "#FF4A4A",
  accent: "#07172d",
  accent2: "#07172d",
  
  // Success/Green colors
  green: "#3dffa0",
  
  // Text colors
  t1: "#000000",
  t2: "#000000",
  t3: "#000000",
};

export default colors;
